import textsUnfiltered from "../textData.json";



export const textContents = textsUnfiltered

export const pickText = (section, subsection) => {
try {
  textsUnfiltered[section][subsection] 
} catch (error) {
  console.log(`error with ${section} ${subsection}`)
}

    return textsUnfiltered[section][subsection]
  }